import React, { useMemo, useCallback } from "react";
import { Marker as LeafletMarker } from "react-leaflet";
import L from "leaflet";

function makeLayerDivIcon(color) {
  const safe = color && /^#[0-9A-Fa-f]{6}$/.test(color) ? color : "#C0392B";
  const html =
    "<div style=\"" +
    "width:20px;height:20px;border-radius:50%;" +
    "background:" +
    safe +
    ";border:3px solid #fff;" +
    "box-shadow:0 2px 8px rgba(0,0,0,0.35);" +
    "cursor:pointer;" +
    "\"></div>";
  return L.divIcon({
    className: "caremap-layer-marker-leaflet",
    html,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });
}

const LayerMarker = ({ marker, color, onOpenDetail }) => {
  const { lat, lng, name } = marker ?? {};
  const icon = useMemo(() => makeLayerDivIcon(color), [color]);

  const handleClick = useCallback(
    (e) => {
      if (e?.originalEvent?.stopPropagation) e.originalEvent.stopPropagation();
      if (onOpenDetail) onOpenDetail(marker);
    },
    [marker, onOpenDetail]
  );

  if (typeof lat !== "number" || typeof lng !== "number") return null;

  return (
    <LeafletMarker
      position={[lat, lng]}
      icon={icon}
      eventHandlers={{ click: handleClick }}
      title={name || ""}
    />
  );
};

export default React.memo(LayerMarker);
